import { render, staticRenderFns } from "./oldIndex.vue?vue&type=template&id=da4cf0cc&scoped=true&"
import script from "./oldIndex.vue?vue&type=script&lang=js&"
export * from "./oldIndex.vue?vue&type=script&lang=js&"
import style0 from "./oldIndex.vue?vue&type=style&index=0&id=da4cf0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4cf0cc",
  null
  
)

export default component.exports